import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import BaseModel from 'volta/models/base-model';
import { collectionCommand } from 'volta/utils/api';

import type { IResourceName } from 'volta/models/base-model';
import type { TJobType } from 'volta/models/constants/job-type';

export const Commands = {
  CancelJob: 'CancelJob'
};

export const ResourceName: IResourceName = {
  singular: 'job',
  plural: 'jobs'
};

// Collection commands

export default class JobHisto extends BaseModel {
  static modelName = 'job' as const;
  static cancelJob = collectionCommand<{ entityId: string }, JobHisto, typeof JobHisto>(
    Commands.CancelJob
  );

  @attr('string') jobType!: TJobType;
  @attr('date') startedAt?: Date;
  @attr('date') endedAt?: Date;
  @attr('boolean') isSuccess!: boolean;
  @attr('boolean') isCancelled!: boolean;
  @attr('boolean') inProgress!: boolean;
  @attr('string') state?: string;
  @attr('string') result?: string;
  @attr('string') errorMsg?: string;
  @attr('string') scheduleId?: string;
  @attr('string') createdBy?: string;

  [Type] = 'job-histo' as const;
}
